import styled from 'styled-components';

import { colors, shadows } from 'theme/theme';

export const DropdownMenuHolder = styled.menu`
  position: absolute;
  right: 0;
  top: 100%;
  border: 1px solid ${colors.calloutGrey};
  box-shadow: ${shadows.toolbar};
  background: ${colors.white};
  border-radius: 8px 0 8px 8px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 99;
`;
